import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu, X } from "lucide-react";
import { toast } from "sonner";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const navItems = [
    { label: "Home", href: "/" },
    { label: "Melhores Sites", href: "/melhores-sites" },
    { label: "Melhores Sites Completo", href: "/melhores-sites-completo" },
    { label: "Sites Usados", href: "/sites-usados" },
    { label: "Vídeos Usados", href: "/videos-usados" },
    { label: "Sites de Jogos", href: "/jogos" },
    { label: "Lives", href: "/lives" },
    { label: "Vídeos Engraçados", href: "/videos-engracados" },
    { label: "Séries Japonesas", href: "/series-japonesas" },
    { label: "Megazone Downloads", href: "/megazone-downloads" },
    { label: "Hotmart", href: "/hotmart" },
    { label: "Encurtador", href: "/encurtador" },
    { label: "Musicful AI", href: "/musicful" },
    { label: "Nota Fiscal Paulista", href: "/nota-fiscal-paulista" },
    { label: "Rádio Online", href: "/radio-online" },
    { label: "LipSync Tutorial", href: "/lipsync-tutorial" },
    { label: "Tradutor", href: "/translate" },
    { label: "Ferramentas de Design", href: "/design-tools" },
    { label: "Tools", href: "#tools" },
    { label: "Create", href: "#create" },
    { label: "Adi", href: "#adi" },
    { label: "Gallery", href: "#gallery" },
    { label: "Cotações", href: "/cotacao" },
    { label: "LuckySpin BTC", href: "/luckyspin" },
    { label: "Neobux", href: "/neobux-estrategia" },
    { label: "Rumble", href: "/rumble" },
    { label: "Palavra Viva", href: "/palavra-viva" },
    { label: "Corte Certo", href: "/corte-certo" },
    { label: "Canal de Oração", href: "/canal-oracao" },
    { label: "Trilhos e Trem", href: "/trilhos-trem" },
    { label: "Sonic Sprount", href: "/sonic-sprount" },
    { label: "CraftyCreations", href: "/crafty-creations" },
    { label: "Planeta Terra Chamando", href: "/planeta-terra-chamando" },
    { label: "Meus Canais", href: "/meus-canais" },
  ];
  
  const handleSignIn = () => {
    toast.info("Sign in feature coming soon!");
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-background/90 backdrop-blur-sm z-50 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0 flex items-center">
            <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center mr-2">
              <span className="text-primary-foreground font-bold">S</span>
            </div>
            <span className="text-xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Sussurros da Meia-Noite
            </span>
          </div>
          
          {/* Desktop navigation */}
          <nav className="hidden md:block">
            <ul className="flex space-x-8">
              {navItems.map((item, index) => (
                <li key={index}>
                  <a 
                    href={item.href}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          
          <div className="hidden md:block">
            <Button 
              onClick={handleSignIn}
              className="bg-primary text-primary-foreground hover:bg-primary/90"
            >
              Sign In
            </Button>
          </div>
          
          {/* Mobile navigation */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-card text-card-foreground">
                <div className="flex justify-end">
                  <Button variant="ghost" size="icon" onClick={() => setIsOpen(false)}>
                    <X className="h-6 w-6" />
                  </Button>
                </div>
                <nav className="mt-8">
                  <ul className="space-y-4">
                    {navItems.map((item, index) => (
                      <li key={index}>
                        <a 
                          href={item.href}
                          className="text-foreground hover:text-foreground/80 text-lg block py-2"
                          onClick={() => setIsOpen(false)}
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-8">
                    <Button 
                      onClick={() => {
                        setIsOpen(false);
                        handleSignIn();
                      }}
                      className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
                    >
                      Sign In
                    </Button>
                  </div>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;